import IsochroneMapLayer from './IsochroneMapLayer';
export default IsochroneMapLayer;
